import { render, staticRenderFns } from "./ViewerToolbar.vue?vue&type=template&id=4fde9b98&scoped=true"
import script from "./ViewerToolbar.vue?vue&type=script&lang=js"
export * from "./ViewerToolbar.vue?vue&type=script&lang=js"
import style0 from "./ViewerToolbar.vue?vue&type=style&index=0&id=4fde9b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde9b98",
  null
  
)

export default component.exports